module.exports = __webpack_public_path__ + "img/baoz1.8aee20ed.png";